import { convertMsToTimeString } from "TimeHelper";
import { TrackTableCell } from "./styles";
import { selectTournamentDriverName } from "selectors/Roster";
import { useAppSelector } from "app/hooks";

interface Props {
  driverId: string;
  tournamentId: string;
  finishTimeMs: number | undefined;
  leftBorder?: boolean;
  alternateBackground?: boolean;
}

export const DriverRoundTime = ({
  driverId,
  tournamentId,
  finishTimeMs,
  leftBorder,
  alternateBackground,
}: Props) => {
  const driverName = useAppSelector((state) =>
    selectTournamentDriverName(state, driverId, tournamentId)
  );
  var timeText = "";
  if (!finishTimeMs) {
    timeText = !!driverName ? "-:--.---" : "";
  } else if (finishTimeMs < 0) {
    timeText = "DNF";
  } else {
    timeText = convertMsToTimeString(finishTimeMs);
  }

  return (
    <>
      <TrackTableCell
        alternateBackground={alternateBackground}
        leftBorder={leftBorder}
      >
        {driverName ?? (!!timeText ? "???" : "")}
      </TrackTableCell>
      <TrackTableCell alternateBackground={alternateBackground}>
        {timeText}
      </TrackTableCell>
    </>
  );
};
